// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2GEJ7","file":"styles_file__1rbDw"};